import { GridColumn, SortState } from '../../types/grid.types'
import HeadCell from './HeadCell'

export interface GridHeadProps<T> {
  columns: GridColumn<T>[]
  sortState: SortState<T>
  onSort: (key: keyof T) => void
}

export const GridHead = <T,>({ columns, sortState, onSort }: GridHeadProps<T>) => (
  <thead>
    <tr>
      {columns.map((col) => (
        <HeadCell
          key={String(col.key)}
          column={col}
          sortState={sortState}
          onSort={onSort}
        />
      ))}
    </tr>
  </thead>
)

export default GridHead
